import { Avatar, Grid, Stack } from '@mui/material';
import { AppImages } from 'app/appImages';
import { MprcChip } from 'components';
import { AutoCompleteDataModel, AutoCompleteSuggestions } from 'components/MprcAutoComplete';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserAutoComplete } from 'views/foundation/user/components/UserAutoComplete';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    channelId: string;
    onError: (e: any) => void;
    onItemsChange: (members: string[]) => void;
}
////////////////////////////////////////////////////////////////////////////

export const AddUsers: React.FC<IProps> = (props) => {

    const api = useCoreApi();
    const { channelId, onItemsChange, onError } = props;
    const { t } = useTranslation("knowledge");
    const [selectedUsers, setSelectedUsers] = useState<AutoCompleteDataModel[]>([]);

    ////////////////////////////////////////////////////////////////////////////

    ///
    const onChange = (item: AutoCompleteDataModel[]) => {
        if (item.length > 0) {
            if (selectedUsers.findIndex(x => x.key == item[0].key) === -1) {
                setSelectedUsers([...selectedUsers, item[0]]);
            }
        }
    };

    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        onItemsChange(selectedUsers.map(x => x.key));
    }, [selectedUsers]);

    return <Grid container spacing={2} direction="column" sx={{ minHeight: 150 }}>
        <Grid>
            <UserAutoComplete
                autoFocus
                selectedItems={[]}
                multiSelect={true}
                onChange={onChange}
                onError={onError}
                placeholder={t("Channel.Edit.Members.UsersPlaceholder")}
                onGetDataCustom={({ searchText, pageNumber, pageSize }, signal) =>
                    new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve, reject) => {
                        api.v1.knowledgeSuggestions.channelMemberUsers({
                            channelId,
                            searchText: searchText ?? null,
                            pageNumber,
                            pageSize
                        }, { signal })
                            .then(result => resolve(result.data))
                            .catch(e => reject(e));
                    })
                }
            />
        </Grid>
        <Grid>
            <Stack direction="row" spacing={1}>
                {selectedUsers.map(item => {
                    return <MprcChip
                        size="small"
                        key={item.key}
                        label={item.label}
                        onDelete={() => {
                            const newSelectedUsers = selectedUsers.filter(x => x.key != item.key);
                            setSelectedUsers(newSelectedUsers);
                        }}
                        avatar={
                            <Avatar
                                src={item.thumbnailUrl == null
                                    ? AppImages.UserThumbnail
                                    : item.thumbnailUrl
                                }
                            />
                        }
                    />;
                })}
            </Stack>
        </Grid>
    </Grid>;
};
